import { SessionInfo, AccountInfo } from "@/types";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface SessionState extends SessionInfo {
  loading: boolean;
  error?: string;
}

const initialState: SessionState = {
  session: {
    id: 0,
    userAccountId: undefined,
    createdAt: undefined,
    updatedAt: undefined,
    deletedAt: undefined
  },
  user: undefined,
  loading: false,
  error: undefined
};

export const sessionSlice = createSlice({
  name: 'session',
  initialState,
  reducers: {
    loginStart: (state) => {
      state.loading = true;
      state.error = undefined;
    },
    loginSuccess: (state, action: PayloadAction<SessionInfo>) => {
      state.loading = false;
      state.session = action.payload.session;
      state.user = action.payload.user;
    },
    loginFailure: (state, action: PayloadAction<string>) => {
      state.loading = false;
      state.error = action.payload;
    },
    logout: (state) => {
      state.session = initialState.session;
      state.user = undefined;
      state.loading = false;
      state.error = undefined;
    },
    updateSession: (state, action: PayloadAction<Partial<SessionInfo>>) => {
      if (action.payload.session) {
        state.session = { ...state.session, ...action.payload.session };
      }
      if (action.payload.user) {
        state.user = { ...state.user, ...action.payload.user } as AccountInfo;
      }
    },
    updateUserProfile: (state, action: PayloadAction<Partial<AccountInfo>>) => {
      if (state.user) {
        state.user = { ...state.user, ...action.payload };
      }
    },
    clearError: (state) => {
      state.error = undefined;
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.loading = action.payload;
    }
  }
});

export const {
  loginStart,
  loginSuccess,
  loginFailure,
  logout,
  updateSession,
  updateUserProfile,
  clearError,
  setLoading
} = sessionSlice.actions;

export default sessionSlice.reducer;
